import React, { Component, FormEvent, ReactNode } from 'react';
import CustomTable from '../../custom/CustomTable';
import TransactionVariableCreatorComponent from './TransactionVariableCreatorComponent';
import { ColumnProps } from 'primereact/column';
import { RouteProps, withFormica } from '../../../helpers/withFormica';
import { TransactionVariableJsonModel } from '../../../domain/stream/transaction/TransactionDomains';
import { DateVariableProperties, VariableProperties } from '../../../domain/datatype/VariablePropertiesDomains';
import DataType from '../../../constant/DataType';
import { DataStructure } from '../../../domain/structure/DataStructureDomains';
import { isStringValid } from '../../../util/Generator';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import CustomInput from '../../custom/CustomInput';
import CustomPaginator, { CustomPaginatorProps } from '../../custom/CustomPaginator';
import DataTypeSelectBoxComponent from '../../custom/DataTypeSelectBoxComponent';
import { RootState } from '../../../redux/store';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { changeEvent, changeEventIsUpdate } from '../../../redux/actions/ChannelActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../../RoleHelper';
import { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import { DataTableSelectionChangeParams } from 'primereact/datatable';
import EmptyListComponent from '../../custom/empty-components/EmptyListComponent';
import TransactionService from '../../../service/TransactionService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { EventState } from '../../../redux/reducers/TransactionReducer';
import ComponentName from '../../../constant/ComponentName';
import Icon from '../../../icons/Icon';
import LanguageUtil from '../../../util/LanguageUtil';

class TransactionVariableListComponent extends Component<Props, State> {
  public state = new State();

  private readonly transactionService: TransactionService = ServiceContainer.getInstance().get(ServiceNames.CHANNEL);

  public render(): ReactNode {
    const {
      event: { event },
    } = this.props;
    const { dataStructures, rows, totalRecords, currentPage, selections } = this.state;
    return (
      <div className={'flex flex-col w-full h-full !max-h-[calc(100vh-18.75rem)] scrollable-editor-container overflow-y-scroll px-5'}>
        <TransactionVariableCreatorComponent removeEventVariables={this.removeEventVariables} selections={selections} dataStructures={dataStructures} />
        {event.variables.length == 0 ? (
          <EmptyListComponent />
        ) : (
          <div className={''}>
            <CustomTable
              value={event.variables}
              data-testid={`${ComponentName.TRANSACTION}_variable_list`}
              columns={this.getColumns()}
              selectionMode={'checkbox'}
              selectionPageOnly
              onSelectionChange={this.onSelectionChange}
              selection={this.state.selections}
            />
          </div>
        )}
        <CustomPaginator
          currentPage={currentPage}
          currentRecords={event.variables.length}
          rows={rows}
          totalRecords={totalRecords}
          rowsPerPageOptions={[10, 20, 50, 100]}
          onPageChange={this.onPageChange}
        />
      </div>
    );
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.transaction.table.name', defaultMessage: 'Name' }),
        className: 'w-1/4',
        body: (record: TransactionVariableJsonModel) => {
          return (
            <CustomInput
              inputType={'ghost'}
              type={'text'}
              disabled={!RoleHelper.canEdit('Transaction') || this.isEventDeployed() || this.isDepend(record.name)} // TODO Event variable dependency checker apisi yazılacak true false dönecek.
              onChange={(e) => this.onChangeVariableName(e, record)}
              value={record.name}
              data-testid={`${ComponentName.TRANSACTION}_variable_list_name_input`}
            />
          );
        },
      },
      {
        field: 'type',
        header: LanguageUtil.get({ id: 'pages.transaction.table.type', defaultMessage: 'Type' }),
        className: 'w-1/4',
        body: (record: TransactionVariableJsonModel) => {
          return (
            <div className={'w-full flex justify-start items-center bg-transparent'}>
              <DataTypeSelectBoxComponent
                ghost={true}
                className={'!border-none hover:!border-none !bg-transparent focus:!outline-none hover:!outline-none'}
                properties={record.properties}
                disabled={this.isFieldDisabled(record)}
                disableSelect={this.isFieldDisabled(record)}
                onChangeValue={(e: FormicaSelectBoxItem) => {
                  this.onChangeDataType(record, e);
                }}
                data-testid={`${ComponentName.TRANSACTION}_variable_list_datatype_selectbox`}
              />
            </div>
          );
        },
      },
      {
        field: 'format',
        header: LanguageUtil.get({ id: 'pages.transaction.table.format', defaultMessage: 'Date Format' }),
        className: 'w-1/6',
        columnKey: 'format',
        body: (record: TransactionVariableJsonModel) => {
          const disabled = !RoleHelper.canEdit('Transaction');
          return (
            <div className={'w-full flex justify-start'}>
              {record.properties.dataType == DataType.DATE && (
                <CustomInput
                  inputType={'ghost'}
                  disabled={disabled}
                  onChange={(e) => this.onChangeDateFormat(e, record)}
                  value={(record.properties as DateVariableProperties).format}
                  data-testid={`${ComponentName.TRANSACTION}_variable_list_dateformat_input`}
                />
              )}
            </div>
          );
        },
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.transaction.table.description', defaultMessage: 'Description' }),
        className: 'w-1/4',
        body: (record: TransactionVariableJsonModel) => {
          return (
            <CustomInput
              inputType={'ghost'}
              disabled={!RoleHelper.canEdit('Transaction')}
              onChange={(e) => this.onChangeDescription(e, record)}
              value={record.description}
              data-testid={`${ComponentName.TRANSACTION}_variable_list_displayname_input`}
            />
          );
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.transaction.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[60px] 2xl:max-w-[100px]',
        alignHeader: 'center',
        sortable: false,
        body: (eventVariable: TransactionVariableJsonModel) => {
          const disabled = !RoleHelper.canEdit('Transaction') || this.isEventDeployed();
          return (
            <div
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                !disabled &&
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeEventVariable(eventVariable),
                    message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                  });
              }}
              className={'flex w-full h-full items-center justify-center'}
              data-testid={`${ComponentName.TRANSACTION}_variable_list_remove_button`}
            >
              <Icon
                icon={'delete'}
                size={20}
                color={'primary'}
                className={`hover:text-primary text-[#607080] ${disabled ? 'cursor-not-allowed' : 'hover:cursor-pointer'} flex items-center justify-center`}
              />
            </div>
          );
        },
      },
    ];
  };

  private onChangeDescription = (e: FormEvent<HTMLInputElement>, record: TransactionVariableJsonModel) => {
    const {
      changeEvent,
      event: { event },
    } = this.props;
    record.description = e.currentTarget.value;
    changeEvent(event);
  };

  private onChangeDateFormat = (e: FormEvent<HTMLInputElement>, record: TransactionVariableJsonModel) => {
    const {
      changeEvent,
      event: { event },
    } = this.props;
    (record.properties as DateVariableProperties).format = e.currentTarget.value;
    changeEvent(event);
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    this.setState({ rows: event.rows, currentPage: event.page });
  };

  private onChangeDataType = (record: TransactionVariableJsonModel, e: FormicaSelectBoxItem) => {
    const {
      changeEvent,
      event: { event },
    } = this.props;
    if (event.stage != 'DRAFT') return;
    record.properties = e.properties || { dataType: DataType.STRING };
    changeEvent(event);
  };

  private onChangeVariableName = (e: FormEvent<HTMLInputElement>, record: TransactionVariableJsonModel) => {
    const {
      event: { event },
      changeEvent,
    } = this.props;
    const value = e.currentTarget.value.trim();
    if (isStringValid(value)) {
      record.name = value;
      changeEvent(event);
    } else {
    }
  };

  private setSelections = (selections: TransactionVariableJsonModel[]) => {
    this.setState({ selections });
  };

  private removeEventVariables = (eventVariable: TransactionVariableJsonModel) => {
    const { selections } = this.state;
    if (selections.length > 0) {
      selections.forEach((s) => this.removeEventVariable(s));
      this.setSelections([]);
    } else {
      this.removeEventVariable(eventVariable);
      this.setSelections([]);
    }
  };

  private removeFromSelections = (variable: TransactionVariableJsonModel) => {
    const { selections } = this.state;
    const index = selections.indexOf(variable);
    if (index != -1) {
      selections.splice(index, 1);
      this.setState({ selections });
    }
  };

  private removeEventVariable = async (eventVariable: TransactionVariableJsonModel) => {
    const {
      event: { event, dependencies },
    } = this.props;
    await this.transactionService.removeEventVariable(event, eventVariable, dependencies);
    this.removeFromSelections(eventVariable);
  };

  private onSelectionChange = (e: DataTableSelectionChangeParams) => {
    this.setState({ selections: e.value });
  };

  private isEventDeployed = () => {
    const {
      event: { event },
    } = this.props;
    return event.stage != 'DRAFT';
  };

  private isDepend = (name: string) => {
    const {
      event: { dependencies },
    } = this.props;
    return dependencies.some((d) => d.dependentId == name && d.dependentType == ComponentName.TRANSACTION_VARIABLE);
  };

  private isFieldDisabled = (record: TransactionVariableJsonModel) => {
    return !RoleHelper.canEdit('Transaction') || this.isEventDeployed() || this.isDepend(record.name);
  };
}

class State {
  name: string = '';
  description: string = '';
  properties: VariableProperties = { dataType: DataType.STRING };
  dataStructures: Array<DataStructure> = new Array<DataStructure>();
  selections: TransactionVariableJsonModel[] = [];
  currentPage: number = 1;
  rows: number = 0;
  totalRecords: number = 0;
  loading: boolean = true;
}

interface Props extends RouteProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  event: state.event as EventState,
  isUpdate: state.event.isUpdate,
});
const mapDispatchToProps = { enterComponent, leaveComponent, changeEvent, changeEventIsUpdate };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(TransactionVariableListComponent));
